export default function SafetySection() {
  const stats = [
    { value: "1000+", label: "Links Verificados" },
    { value: "10k+", label: "Produtos Organizados" },
    { value: "99%", label: "Taxa de Segurança" },
    { value: "24h", label: "Atualizações" },
  ];

  return (
    <section className="relative bg-accent-50/50 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          {/* Left: Text */}
          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-100 rounded-full mb-4">
              Segurança
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-6">
              Hoobuy é Seguro?
            </h2>
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                <strong className="text-foreground-900">Sim, o Hoobuy é uma plataforma segura</strong> quando utilizada com as devidas precauções.
                Todos os links na nossa spreadsheet passam por revisão manual antes de serem adicionados.
              </p>
              <p>
                Não vendemos produtos diretamente. O nosso objetivo é ajudar utilizadores a encontrar vendedores confiáveis
                e produtos de qualidade através de uma planilha organizada e constantemente atualizada.
              </p>
              <p>
                Recomendamos sempre utilizar um agente de confiança, verificar avaliações e comparar preços antes de finalizar qualquer compra.
              </p>
            </div>
          </div>

          {/* Right: Stats */}
          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-2xl p-6 md:p-8 text-center"
                >
                  <span className="block font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-2">
                    {stat.value}
                  </span>
                  <span className="block text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}